/* Copyright (c) 2024 Xperi. All Rights Reserved. */

// eslint-disable-next-line no-shadow
export enum ContentType {
    CONTENT_ID = 'contentId',
    OFFER_ID = 'offerId',
    RECORDING_ID = 'recordingId',
}
